// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

function OnLoadingContentViewForModal(props) {
  return (
    <div className="on_loading_content_view_for_modal text-center">
      {props.displayMessage &&
        <i className="fa fa-spinner fa-spin" />
      }
    </div>
  );
}

OnLoadingContentViewForModal.propTypes = {
  /**
   * Should we display a loading message ?
   */
  displayMessage: PropTypes.bool
};

OnLoadingContentViewForModal.defaultProps = {
  displayMessage: true
};

export default OnLoadingContentViewForModal;
